import React from "react";

function Home () {
    
return (
    <div className="homepage">
        <div className="centercontent">
        <h1>DIY Heritage</h1>
        <h2>Do It Yourself. Don’t wait for anyone else to save what’s valuable to you.</h2>
        </div>
    </div>
)

}

export default Home;